import { Autocomplete, Chip, MenuItem, Stack, TextField } from '@mui/material'
import PADUChip from '../../controls/PADUChip'
import { EditorField } from './schemaEditorReducer'

interface P {
    type: 'preferred' | 'acceptable' | 'discouraged' | 'unacceptable'
    field: EditorField
    onUpdateField: (
        fieldId: string,
        updates: Partial<EditorField>
    ) => void
}

const OPERATIONS = {
    number: ['greater', 'greater-equal', 'equal', 'smaller', 'smaller-equal', 'between'],
    date: ['greater', 'greater-equal', 'equal', 'smaller', 'smaller-equal', 'between'],
    string: ['equal', 'contains', 'not-contains', 'starts-with', 'ends-with']
}

const PaduRow = ({ type, field, onUpdateField }: P) => {
    if (!field.padu) return null

    const row = field.padu[type]
    if (!row) return null

    const isDate = field.type === 'date'
    const isString = field.type === 'string'

    const operation = row.operation
    const value = row.value

    return (
        <Stack direction='row' spacing={2} alignItems='center'>

            {/* CHIP */}
            <PADUChip
                compiledPADU={{
                    key: field.key,
                    paduSetting: field.padu,
                    status: type
                }}
            />

            {/* OPERATION */}
            <TextField
                select
                size='small'
                value={operation}
                onChange={e =>
                    onUpdateField(field._id, {
                        padu: {
                            ...field.padu,
                            [type]: {
                                ...row,
                                operation: e.target.value as any
                            }
                        }
                    })}
                sx={{ width: 150 }}>

                {OPERATIONS[field.type].map(op => (
                    <MenuItem key={op} value={op}>{op}</MenuItem>
                ))}

            </TextField>

            {/* VALUE / RANGE */}
            { !isString && operation === 'between'
                ? (
                        <>
                            <TextField
                                size='small'
                                type={isDate ? 'date' : isString ? 'text' : 'number'}
                                label='From'
                                InputLabelProps={isDate ? { shrink: true } : undefined}
                                value={
                                    isDate
                                        ? ((value as any)?.from ?? '')
                                        : ((value as any)?.from ?? '')
                                }
                                onChange={e =>
                                    onUpdateField(field._id, {
                                        padu: {
                                            ...field.padu,
                                            [type]: {
                                                ...row,
                                                value: {
                                                    ...(value as any),
                                                    from:
                        e.target.value === ''
                            ? undefined
                            : isDate
                                ? e.target.value
                                : Number(e.target.value)
                                                }
                                            }
                                        }
                                    })}
                            />

                            <TextField
                                size='small'
                                type={isDate ? 'date' : isString ? 'text' : 'number'}
                                label='To'
                                InputLabelProps={isDate ? { shrink: true } : undefined}
                                value={
                                    isDate
                                        ? ((value as any)?.to ?? '')
                                        : ((value as any)?.to ?? '')
                                }
                                onChange={e =>
                                    onUpdateField(field._id, {
                                        padu: {
                                            ...field.padu,
                                            [type]: {
                                                ...row,
                                                value: {
                                                    ...(value as any),
                                                    to:
                        e.target.value === ''
                            ? undefined
                            : isDate
                                ? e.target.value
                                : Number(e.target.value)
                                                }
                                            }
                                        }
                                    })}
                            />
                        </>
                    )
                : (
                        isString
                            ? (
                                    <Autocomplete
                                        fullWidth
                                        multiple
                                        freeSolo
                                        options={[]}
                                        value={Array.isArray(value) ? value : []}
                                        onChange={(_, newValue) =>
                                            onUpdateField(field._id, {
                                                padu: {
                                                    ...field.padu,
                                                    [type]: {
                                                        ...row,
                                                        value: newValue.length === 0 ? undefined : newValue
                                                    }
                                                }
                                            })}
                                        renderTags={(value: string[], getTagProps) =>
                                            value.map((option: string, index: number) => {
                                                const tagProps = getTagProps({ index })

                                                return (
                                                    <Chip
                                                        key={`${option}-${index}`}
                                                        variant='outlined'
                                                        label={option}
                                                        {...tagProps}
                                                    />
                                                )
                                            })}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label='Allowed Values'
                                                placeholder='Type and press Enter'
                                            />
                                        )}
                                    />
                                )
                            : (
                                    <TextField
                                        size='small'
                                        type={isDate ? 'date' : isString ? 'text' : 'number'}
                                        InputLabelProps={isDate ? { shrink: true } : undefined}
                                        value={
                                            isDate
                                                ? (typeof value === 'string' ? value : '')
                                                : (typeof value === 'number' ? value : '')
                                        }
                                        onChange={e =>
                                            onUpdateField(field._id, {
                                                padu: {
                                                    ...field.padu,
                                                    [type]: {
                                                        ...row,
                                                        value:
                                                e.target.value === ''
                                                    ? undefined
                                                    : isDate
                                                        ? e.target.value
                                                        : Number(e.target.value)
                                                    }
                                                }
                                            })}
                                    />
                                )
                    )}

        </Stack>
    )
}

export default PaduRow
